import React from 'react'

const Security = () => {
  return (
    <div className="p-6 bg-white border-2 border-gray-300 rounded-md w-full mx-auto">
    <h2 className="text-lg font-medium text-[#333333] mb-4 underline">Security</h2>
    <table className=" ">
      <tbody>
        <tr className="">
          <td className="p-3 font-medium text-sm text-[#333333]">Password:</td>
          <td className="p-3 text-sm text-[#333333]">LBINXXXXX</td>
        
        </tr>
       
      </tbody>
    </table>
  </div>
  )
}

export default Security